import React from "react"
import { Drawer, Classes, DrawerProps } from "@blueprintjs/core"
import classNames from "utils/classNames"
export interface CustomDrawerProps extends DrawerProps {
  footer?: React.FC | Element | any
  drawerClassName?: string
}
const CustomDrawer = ({
  children,
  isOpen,
  onClose,
  footer,
  position,
  className,
  drawerClassName,
  ...props
}: CustomDrawerProps) => {
  return (
    <Drawer
      className={drawerClassName}
      isOpen={isOpen}
      position={position}
      onClose={onClose}
      {...props}
    >
      <div className={classNames(Classes.DRAWER_BODY, className)}>
        {children}
      </div>
      {footer && <div className={Classes.DRAWER_FOOTER}>{footer}</div>}
    </Drawer>
  )
}

export default CustomDrawer
